import React, {
	memo,
	useCallback,
	useEffect,
	useMemo,
	useState
} from 'react';
import PropTypes from 'prop-types';

import { useProgramState } from '../../../../../../contexts/ProgramsContext';

import styles from '../../programs.module.css';

const ReadonlyLayout = ( { formData } ) => {
	const { templateModules } = useProgramState();
	const [ availableModules, setAvailableModules ] = useState( templateModules );

	const [ included, setIncluded ] = useState( [] );

	useEffect( () => {
		setAvailableModules( templateModules );
	}, [ templateModules ] );

	useEffect( () => {
		const included = [];

		if ( formData?.layout ) {
			formData.layout.forEach( id => {
				const module = availableModules.find( module => module.id === id );

				if ( module ) {
					included.push( module );
				}
			} );
		}

		setIncluded( included );
	}, [
		availableModules,
		formData
	] );

	const itemStyle = useMemo( () => ( {
		// some basic styles to make the items look a bit nicer
		display: 'flex',
		justifyContent: 'space-between',
		userSelect: 'none',
		padding: '1rem',
		border: '1px solid rgba(34, 36, 38, 0.15)',
		margin: '8px 0',
		background: '#fff',
		boxShadow: 'none',
		transition: ''
	} ), [] );

	const listStyle = useMemo( () => ( {
		padding: '8px 1rem 8px',
		width: 360,
		background: '#fff'
	} ), [] );

	const mapModules = useCallback(
		() => included.map( ( {
			id,
			name
		} ) => (
			<li
				key={ id }
				style={ itemStyle }
			>
				{ name }
			</li>
		) ),
		[
			included,
			itemStyle
		]
	);

	return (
		<div className={ styles.templateLayoutContainer }>
			<div className={ styles.listContainer }>
				<div className={ styles.listHeader }>
					<h4>Included Modules</h4>
				</div>
				<div style={ listStyle }>{ mapModules() }</div>
			</div>
		</div>
	);
};

ReadonlyLayout.propTypes = { formData: PropTypes.object.isRequired };

export default memo( ReadonlyLayout );
